import generalUpload from "../_section/upload.class";
import dayjs from "dayjs";

export class userForm11Upload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}

const template = {
    items: [{
        name: 'year', label: 'Year', type: 'text',
    }, {
        name: 'netProfit', label: 'Net Profit', type: 'currency',
    }]
}

export class adminForm11Upload extends userForm11Upload {

    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.calcValues(template)
        if (this.values.year) {
            let first = dayjs(`${this.values.year}-01-01`);
            this.setDateData({
                dated: first.endOf('year'), expires: first.add(5, 'year').endOf('year'),
            })
        }
    }

    getSectionSummary = () => {
        return [{
            name: this.personalTitle, tags: [{
                name: 'Year', value: this.activeUpload?.values?.year || 'Not Provided'
            }, {
                name: 'Net Profit', value: this.activeUpload?.values?.netProfit || 'Not Provided'
            }]
        }]
    }
}
